import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { cancelSpeech } from "../lib/speech";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    // Hard-stop any in-flight TTS BEFORE we tear down auth state. Otherwise the
    // Web Speech queue keeps reading aloud after the user is already logged out,
    // and the only escape is to navigate off-site entirely.
    try { cancelSpeech(); } catch {}
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("ekkol_token");
    localStorage.removeItem("echostudy_token"); // cleanup legacy
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, checkAuth, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
